import Layers from "slotworks/graphics/layers/layers";
import AutoplayStartButtonControl from "slotworks/smart-ui/controls/button/autoplay-start-button-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import autoplayModel from "slotworks/model/autoplay/autoplay-model";

export default class UKGCAutoplayStartButtonControl extends AutoplayStartButtonControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    protected onClick() {
        const options = new ControlOptions();

        if (this.lossLimitAmountHasBeenPicked() || this.lossLimitAmountIsNotNeeded()) {
            if (this.options.autoplays.currentValue === 0) {
                options.autoplays.currentValue = this.options.autoplays.defaultValue;
            }

            options.flashLossLimit = false;
            super.onClick();
        } else {
            options.flashLossLimit = true;
        }

        this.onChange.dispatch(options);
    }

    private lossLimitAmountHasBeenPicked() {
        return this.options.lossLimit.currentValue > 0;
    }

    private lossLimitAmountIsNotNeeded() {
        return !autoplayModel.lossLimitRequired || !this.options.lossLimit.values;
    }
}
